(function(config) {
    'use strict';

    angular.module('process.services', [
            'ngResource'
        ])
        .factory('processDataSrvc', processDataSrvc)
        .factory('processSrvc', processSrvc)
        .factory('processStageDataSrvc', processStageDataSrvc)
        .factory('processStageSrvc', processStageSrvc)
        .factory('productionCubeDataSrvc', productionCubeDataSrvc)
        .factory('productionCubeProductDataSrvc', productionCubeProductDataSrvc)
        .factory('orderProductProcessStageStatusDataSrvc', orderProductProcessStageStatusDataSrvc);

    processDataSrvc.$inject = ['$resource'];

    function processDataSrvc($resource) {
        return $resource(config.api + '/api/v1/processes/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
            },
            update: {
                method: 'PATCH',
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    processSrvc.$inject = ['processDataSrvc', 'modalSrvc'];

    function processSrvc(processDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    processDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    processStageDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function processStageDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/process-stages/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            forProcess: {
                method: 'GET',
                url: config.api + '/api/v1/process-stages/:pk/admin_for_process/',
                isArray: true,
                params: {
                    pk: '@pk'
                }
            }
        });
    }

    processStageSrvc.$inject = ['processStageDataSrvc', 'modalSrvc'];

    function processStageSrvc(processStageDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    processStageDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productionCubeDataSrvc.$inject = ['$resource'];

    function productionCubeDataSrvc($resource) {
        return $resource(config.api + '/api/v1/production-cubes/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            }
        });
    }

    productionCubeProductDataSrvc.$inject = ['$resource'];

    function productionCubeProductDataSrvc($resource) {
        return $resource(config.api + '/api/v1/production-cube-products/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            toRealizationList: {
                method: 'GET',
                url: config.api + '/api/v1/production-cube-products/admin_to_realization_list/',
                isArray: true,
                params: {
                    process_stage_pk: '@process_stage_pk',
                    products_pks: '@products_pks'
                }
            },
            toRealizationDetail: {
                method: 'GET',
                url: config.api + '/api/v1/production-cube-products/:pk/admin_to_realization_detail/',
                params: {
                    pk: '@pk',
                }
            }
        });
    }

    orderProductProcessStageStatusDataSrvc.$inject = ['$resource'];

    function orderProductProcessStageStatusDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-product-process-stage-statuses/:pk/', { pk: '@pk' }, {
            create: {
                method: 'POST',
                unique: true,
                isArray: true
            },
            list: {
                method: 'GET',
                isArray: true
            },
        });
    }
})(window.config);
